import flatpickr from "flatpickr";
import flatpickrLanguages from "flatpickr/dist/l10n";
import { isHiddenAlt, smoothScrollTo } from "../utils";
import Modal from "./Modal";

class GiftSelect {
  constructor() {
    this.wrapper = document.getElementById("gift-card-wrapper");
    if (this.wrapper) {
      this.amountType = this.wrapper.querySelector("input[name='amount-type']");

      this.amount = this.wrapper.querySelector("input[name='total-amount']");
      this.totalCartAmount = this.wrapper.querySelector('#total-cart-amount');
      this.mobileTotalCartAmount = this.wrapper.querySelector('#mobile-total-cart-amount');
      this.totalCartAmountFooter = this.wrapper.querySelector('#total-cart-amount-footer');
      this.withDeliveryTexts = this.wrapper.querySelectorAll('.with-delivery');
      this.cartGiftCardAmountElts = this.wrapper.querySelectorAll('.cart-gift-card-amount');
      this.amountWithFullBoxPrice = this.wrapper.querySelector('#amount-with-box-full-price');
      this.amountWithFullBoxPriceFooter = this.wrapper.querySelector('#amount-with-box-full-price-footer');
      this.mobileAmountWithFullBoxPrice = this.wrapper.querySelector('#mobile-amount-with-box-full-price');

      // Gift card promo code from the session (campaign link with ?discountcode=), applied at checkout
      this.cartPromoDiscount = this.wrapper.querySelector('#cart-promo-discount');
      this.cartPromoDiscountAmount = this.wrapper.querySelector('#cart-promo-discount-amount');
      this.promo = this.wrapper.dataset.promoValue ? {
        value: Number(this.wrapper.dataset.promoValue),
        isPercentage: this.wrapper.dataset.promoIsPercentage === '1',
        minimum: Number(this.wrapper.dataset.promoMinimum),
        maximum: Number(this.wrapper.dataset.promoMaximum)
      } : null;

      this.cardTypes = this.wrapper.querySelectorAll("input[name='type']");

      this.elementsToShowOnPrint = this.wrapper.querySelectorAll('.showOnPrint');
      this.elementsToHideOnPrint = this.wrapper.querySelectorAll('.hideOnPrint');

      this.elementsToShowOnEgift = this.wrapper.querySelectorAll('.showOnEgift');
      // this.elementsToHideOnEgift = this.wrapper.querySelectorAll('.hideOnEgift');

      this.elementsToShowOnPhysical = this.wrapper.querySelectorAll('.showOnPhysical');
      this.elementsToHideOnPhysical = this.wrapper.querySelectorAll('.hideOnPhysical');

      this.elementsToShowOnBox = this.wrapper.querySelectorAll('.showOnBox');
      this.elementsToHideOnBox = this.wrapper.querySelectorAll('.hideOnBox');

      this.additionalEgiftFormFields = this.wrapper.querySelectorAll('.additional-egift-fields');

      this.languageForm = this.wrapper.querySelector('#language-form');

      // this.chooseCardDesign = this.wrapper.querySelector('#choose-card-design');
      // if(this.chooseCardDesign){
      //   this.handleChooseCardDesign();
      // }

      this.deliverySection = this.wrapper.querySelector('#delivery-section');

      this.physicalSection = this.wrapper.querySelector('#physical-content-section');
      this.wineTourismBoxContent = this.wrapper.querySelector('#box-content');
      this.physicalContent = this.wrapper.querySelector('#physical-content');

      this.addressSection = this.wrapper.querySelector('#address-section');
      this.langsSelect = this.wrapper.querySelector('#select-language');
      this.physicalLangsSelect = this.wrapper.querySelector('#physical-select-language');
      this.physicalSelectWrapper = this.wrapper.querySelector('#physical-select-wrapper');
      if(this.physicalLangsSelect && this.langsSelect && this.physicalSelectWrapper){
        this.handleLangsSelect();
      }

      // this.designSection = this.wrapper.querySelector('#design-section');
      this.removePhysicalOptionButtons = this.wrapper.querySelectorAll('.remove-physical-cart');
      if(this.cardTypes && this.removePhysicalOptionButtons){
        this.handleAddPhysicalCardType();
        this.handleRemovePhysical();
      }

      this.addEgiftCard = this.wrapper.querySelector('.add-egift-section .vertical-gift-card-choice');
      this.addEgiftInput = this.wrapper.querySelector('input[name="add_egift"]');
      this.egiftForm = this.wrapper.querySelector('#egift-form');
      this.removeEgiftCartOptionButtons = this.wrapper.querySelectorAll('.remove-egift-cart');
      if(this.addEgiftInput && this.egiftForm && this.addEgiftCard && this.removeEgiftCartOptionButtons){
        this.handleAddEgift();
        // this.handleConfirmRecipientEmail();
        this.handleRemoveEgift();
      }

      // this.switchAmount = this.wrapper.querySelector('#switch-amount');
      // this.defaultAmountBlock = this.wrapper.querySelector('#default-amount-block');
      this.experienceIdHiddenInput = this.wrapper.querySelector("input[name='experience_id']");
      this.hostIdHiddenInput = this.wrapper.querySelector("input[name='host_id']");
      // if(this.switchAmount && this.defaultAmountBlock){
      //   this.switchAmount.addEventListener('click', () => {
      //     this.handleSwitchAmount();
      //   });
      // }

      // this.amountTypeRadios = this.wrapper.querySelectorAll("input[name='amount-type-radio']");
      // if(this.amountTypeRadios){
      //   this.handleAmountTypes();
      // }

      //-------------CHOOSE AMOUNT PART----------------\\
      this.amounts = this.wrapper.querySelectorAll("input.amountChoice");
      this.amountInput = this.wrapper.querySelector("input[name=amount]");
      this.otherAmount = this.wrapper.querySelector("#otherAmountText");
      this.chooseAmountBlock = this.wrapper.querySelector("#choose-amount-block");

      if (this.amounts && this.amountInput && this.otherAmount && this.chooseAmountBlock) {
        this.amounts.forEach((radio) => {
          radio.addEventListener("change", () => {
            if(radio.checked){
              this.onAmountChange(radio.value, true);
              this.amountInput.value = radio.value;
            }
          });
        });
        this.amountInput.addEventListener("keyup", () => {
          this.onAmountChange(this.amountInput.value);
        });
        this.amountInput.addEventListener("change", () => {
          if(this.amountInput.value < 20){
            this.amountInput.value = 20;
            this.onAmountChange(this.amountInput.value);
          }
        });

        this.otherAmount.addEventListener("click", () => this.onOtherAmountClick());
      }
      //--------------------------------------------------\\

      //handle remove recommendation
      this.removeRecommandationButtons = this.wrapper.querySelectorAll('.remove-recommandation');
      this.recommendationRemovedBlock = this.wrapper.querySelector('#recommendation-removed');
      this.hideOnRemoveReco = this.wrapper.querySelectorAll('.hideOnRemoveReco');
      this.hesitatingTitle = this.wrapper.querySelector('#hesitating-title');
      if(this.removeRecommandationButtons){
        this.removeRecommandationButtons.forEach(button => {
          button.addEventListener('click', () => {
            this.onRemoveRecommendation();
          });
        });
      }

      //handle undo remove recommendation
      this.undoRemoveRecommendation = this.wrapper.querySelector('#undo-remove-reco');
      if(this.undoRemoveRecommendation){
        this.undoRemoveRecommendation.addEventListener('click', () => {
          this.onUndoRemoveRecommendation();
        });
      }

      this.giftKindWords = this.wrapper.querySelector('#gift-kind-words');
      this.kindWordsChar = this.wrapper.querySelector('#kind-words-char');
      if(this.giftKindWords && this.kindWordsChar){
        this.handleCharsCount();
      }

      // this.personalMessageNotice = this.wrapper.querySelector('#personal-message-notice');
      this.deliveryAddressRadios = this.wrapper.querySelectorAll("input[name='address_type']");
      this.addressForm = this.wrapper.querySelector('#delivery-address-form');
      // if(this.deliveryAddressRadios && this.addressForm){
      //   this.handleDeliveryAddressForm();
      // }

      this.regularCartRecap = this.wrapper.querySelector('#regular-cart-recap');
      this.experienceCartRecap = this.wrapper.querySelector('#experience-cart-recap');
      this.giftPackageCartRecap = this.wrapper.querySelector('#gift-package-cart-recap');

      this.countrySelects = this.wrapper.querySelectorAll('.country-select');
      this.expressChoice = this.wrapper.querySelector('#express-choice');
      this.classicInput = this.wrapper.querySelector('#classic');
      this.countriesPricing = JSON.parse(this.deliverySection.dataset.priceByCountry);
      this.classicDeliveryCartPricing = this.wrapper.querySelector('#classic-delivery-cart-price');
      this.regularDeliveryPrice = this.wrapper.querySelector('#regular-delivery-price');
      if(this.countrySelects && this.expressChoice && this.classicInput && this.deliveryAddressRadios && this.countriesPricing && this.classicDeliveryCartPricing){
        this.handleExpressDeliveryFranceOnly();
        this.handleCountryPricing();
      }

      this.deliveryRadios = this.wrapper.querySelectorAll("input[name='delivery_type']");
      this.cartClassicDelivery = this.wrapper.querySelector('.cart-classic-delivery');
      this.cartExpressDelivery = this.wrapper.querySelector('.cart-express-delivery');
      if(this.deliveryRadios && this.cartClassicDelivery && this.cartExpressDelivery){
        this.handleDelivery();
      }

      this.experienceAmount = this.wrapper.querySelector("input[name='experience_amount']");
      this.giftPackageAmount = this.wrapper.querySelector("input[name='gift_package_amount']");
      this.experienceChooseAmount = this.wrapper.querySelector('#experience-choose-amount');
      this.giftCardAmount = this.wrapper.querySelectorAll('.gift-card-amount');
      if(this.experienceChooseAmount){
        this.adults = this.experienceChooseAmount.querySelector('.adults');
        this.children = this.experienceChooseAmount.querySelector('.children');
        // this.experienceGiftCardAmount = this.experienceChooseAmount.querySelector('#experience-gift-card-amount');

        this.useGroupsPricing = this.experienceChooseAmount.hasAttribute('data-use-group-pricing');
        if(this.useGroupsPricing){
          this.groupsPrices = JSON.parse(this.experienceChooseAmount.dataset.groupsPrices);
        }

        this.minus = this.experienceChooseAmount.querySelectorAll('.minus');
        this.plus = this.experienceChooseAmount.querySelectorAll('.plus');
        this.groupSizeNotice = document.querySelector('#group-size-notice');
        this.totalSeatsElt = this.wrapper.querySelector('.total-seats');
        if(this.minus && this.plus && this.adults && this.groupSizeNotice && this.totalSeatsElt){
          this.handleExperienceAmount();
          this.updateTotalSeatsOnCart();
        }
      }

      this.datepicker = this.wrapper.querySelector('#date-send-gift');
      this.sentAtNotice = this.wrapper.querySelector('#sent-at-notice');
      if(this.datepicker && this.sentAtNotice) {
        this.flatpickr = this.initDatePicker(this.datepicker);
      }

      this.egiftSectionImage = this.wrapper.querySelector('#egift-section-image');
      this.printSectionImageCellars = this.wrapper.querySelector('.print-card-image-cellars');
      this.printSectionImageConnoisseur = this.wrapper.querySelector('.print-card-image-connoisseur');
      this.printSectionImageColorBlock = this.wrapper.querySelector('.print-card-image-color-block');
      this.designRadios = this.wrapper.querySelectorAll("input[name='design']");

      // this.previewCurrentGcButtons = this.wrapper.querySelectorAll('.preview-current-gc');
      // if(this.previewCurrentGcButtons){
      //   this.handleGCPreview();
      // }

      this.previewCurrentDesignButtons = this.wrapper.querySelectorAll('.preview-current-design');
      if(this.previewCurrentDesignButtons){
        this.handleDesignPreview();
      }

      this.mobileChooseCards = document.querySelectorAll('.mobile-choose-gift-card');
      if(this.mobileChooseCards){
        this.initMobileChooseGiftCard();
      }

      //init total amount
      this.computeTotalAmount();
    }
  }

  //handle remove recommendation
  onRemoveRecommendation(){
    this.amountType.value = 'default';

    this.recommendationRemovedBlock.classList.remove('hidden');
    this.hideOnRemoveReco.forEach(elt => {
      elt.classList.add('hidden');
    });

    const bestSellerAmount = this.wrapper.querySelector('input.amountChoice.best-seller');
    if(bestSellerAmount) bestSellerAmount.checked = true;

    if(this.hesitatingTitle){
      this.hesitatingTitle.classList.add('hidden');
    }

    this.onAmountChange(bestSellerAmount.value, true);
  }

  //handle undo remove recommendation
  onUndoRemoveRecommendation(){
    if(this.experienceAmount){
      this.amountType.value = 'experience-based';
    }
    else if(this.giftPackageAmount){
      this.amountType.value = 'gift-package-based';
    }

    this.recommendationRemovedBlock.classList.add('hidden');
    this.hideOnRemoveReco.forEach(elt => {
      elt.classList.remove('hidden');
    });
    if(this.hesitatingTitle){
      this.hesitatingTitle.classList.remove('hidden');
    }

    if(this.experienceAmount){
      this.computeExperienceGiftAmount();
      this.updateTotalSeatsOnCart();
    }
    else if(this.giftPackageAmount){
      this.computeTotalAmount();
    }

    this.uncheckCurrentCheckedAmount();
    this.handleCartProductRecapVisibility(false);
  }

  handleLangsSelect(){
    //if lang value is FR, set physical lang value to FR
    //same for EN
    if(this.langsSelect && this.physicalLangsSelect){
      this.langsSelect.addEventListener('change', () => {
        const gcPhysicalType = this.wrapper.querySelector("input[name='type']:checked");

        if(this.langsSelect.value == 1 || this.langsSelect.value == 2){
          this.physicalLangsSelect.value = this.langsSelect.value;

          this.physicalSelectWrapper.classList.add('hidden');

          if(gcPhysicalType && gcPhysicalType.value == 'physical'){
            this.physicalSection.classList.add('hidden');
          }
        }
        else{
          this.physicalLangsSelect.value = 2;

          if(gcPhysicalType){
            this.physicalSelectWrapper.classList.remove('hidden');
            this.physicalSection.classList.remove('hidden');
          }
        }
      });
    }
  }

  handleAddEgift(){
    const selectLabel = this.addEgiftCard.querySelector('.select-label');
    const removeOptionButton = this.addEgiftCard.querySelector('.remove-egift-cart');

    this.addEgiftInput.addEventListener('change', () => {
      this.addEgiftCard.classList.toggle('selected');
      this.egiftForm.classList.toggle('hidden');
      if(removeOptionButton){
        removeOptionButton.classList.toggle('hidden');
        removeOptionButton.classList.toggle('lg:invisible');
        removeOptionButton.classList.toggle('lg:block');
      }

      if(this.elementsToShowOnEgift){
        this.elementsToShowOnEgift.forEach((elt) => {
          elt.classList.toggle('hidden');
        });
      }

      if(this.addEgiftInput.checked){
        if(selectLabel) selectLabel.textContent = selectLabel.dataset.selected;
        // this.toggleLangsAvailable(false);

        // this.languageForm.textContent = this.languageForm.dataset.textEmail;

        this.additionalEgiftFormFields.forEach(field => {
          field.parentElement.classList.remove('hidden');
          this.toggleInputsDisableInElement(field, false);
          this.toggleInputsRequiredInElement(field, true);
        });

      }
      else{
        if(selectLabel) selectLabel.textContent = selectLabel.dataset.select;

        this.additionalEgiftFormFields.forEach(field => {
          field.parentElement.classList.add('hidden');
          this.toggleInputsDisableInElement(field, true);
          this.toggleInputsRequiredInElement(field, false);
        });
      }
    });
  }

  // handleConfirmRecipientEmail(){
  //   this.recipientEmailInputWrappers = this.wrapper.querySelectorAll('.recipient-email-input-wrapper');
  //   this.recipientEmail = this.wrapper.querySelector('#recipient-email');
  //   this.recipientEmailConfirm = this.wrapper.querySelector('#recipient-email-confirm');
  //   this.recipientEmailsMustMatchNotices = this.wrapper.querySelectorAll('.recipient-emails-must-match-notice');
  //   // this.submitButtons = this.wrapper.querySelectorAll('button[type="submit"]');

  //   if(this.recipientEmail && this.recipientEmailConfirm && this.recipientEmailsMustMatchNotices && this.recipientEmailInputWrappers){
  //     const checkEmailMatch = () => {
  //       const isMatch = this.recipientEmail.value === this.recipientEmailConfirm.value;
  //       this.recipientEmailsMustMatchNotices.forEach(notice => notice.classList.toggle('hidden', isMatch));
  //       // this.submitButtons.forEach(button => button.disabled = !isMatch);

  //       this.recipientEmailInputWrappers.forEach(field => {
  //         field.classList.toggle('invalid', !isMatch);
  //       });
  //     };

  //     this.recipientEmailConfirm.addEventListener('change', checkEmailMatch);
  //     this.recipientEmail.addEventListener('change', () => {
  //       if(this.recipientEmailConfirm.value !== '') {
  //         checkEmailMatch();
  //       }
  //     });
  //   }
  // }

  //handle remove egift option
  handleRemoveEgift(){
    this.removeEgiftCartOptionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.addEgiftInput.checked = false;
        this.addEgiftInput.dispatchEvent(new Event('change'));
        // this.submitButtons.forEach(button => button.disabled = false);
      });
    });
  }

  handleAddPhysicalCardType(){
    this.cardTypes.forEach((cardRadio) => {
      const mainChoice = cardRadio.closest('.vertical-gift-card-choice');

      let selectLabel = null;
      if(mainChoice){
        selectLabel = mainChoice.querySelector('.select-label');
      }

      cardRadio.addEventListener('change', () => {
        const cardWrapper = this.wrapper.querySelector('.choose-wrapper .vertical-gift-card-choice.selected');
        if(cardWrapper){
          cardWrapper.classList.remove('selected');
        }

        const currentCardWrapper = cardRadio.closest('.vertical-gift-card-choice');
        if(currentCardWrapper){
          currentCardWrapper.classList.add('selected');
        }

        this.resetPhysicalCardLabels();

        if(cardRadio.checked){
          if(selectLabel) selectLabel.textContent = selectLabel.dataset.selected;
          switch(cardRadio.value){
            case 'physical':
              this.handlePhysicalCartVisibility();

              this.deliverySection.classList.remove('hidden');
              if(this.physicalSection) this.physicalSection.classList.remove('hidden');
              if(this.wineTourismBoxContent) this.wineTourismBoxContent.classList.add('hidden');
              if(this.physicalContent) this.physicalContent.classList.remove('hidden');

              this.addressSection.classList.remove('hidden');
              this.toggleInputsDisableInElement(this.addressForm, false);
              this.toggleInputsRequiredInElement(this.addressForm, true);
              this.toggleInputsDisableInElement(this.deliverySection, false);

              // this.toggleLangsAvailable(true);

              this.deliveryAddressRadios.forEach(radio => {
                radio.dispatchEvent(new Event('change'));
              });

              this.deliveryRadios.forEach(deliveryRadio => {
                deliveryRadio.dispatchEvent(new Event('change'));
              });

              //scroll to the content of the box on mobile
              // if (window.innerWidth < 768) {
              //   smoothScrollTo(this.physicalSection);
              // }

              this.removePhysicalOptionButtons.forEach(button => {
                if(button.classList.contains('on-card') && button.classList.contains('physical')){
                  button.classList.remove('hidden');
                  button.classList.remove('lg:invisible');
                  button.classList.remove('lg:block');
                }

                else if(button.classList.contains('on-card') && button.classList.contains('box')){
                  button.classList.add('hidden');
                  button.classList.add('lg:invisible');
                  button.classList.add('lg:block');
                }
              });

              if(this.langsSelect.value == 1 || this.langsSelect.value == 2){
                this.physicalSelectWrapper.classList.add('hidden');
                this.physicalSection.classList.add('hidden');
              }
              else{
                this.physicalSelectWrapper.classList.remove('hidden');
                this.physicalSection.classList.remove('hidden');
              }

              break;
            case 'box':
              this.handleBoxCartVisibility();

              this.deliverySection.classList.remove('hidden');
              if(this.physicalSection) this.physicalSection.classList.remove('hidden');
              if(this.wineTourismBoxContent) this.wineTourismBoxContent.classList.remove('hidden');
              if(this.physicalContent) this.physicalContent.classList.add('hidden');

              this.addressSection.classList.remove('hidden');
              this.toggleInputsDisableInElement(this.addressForm, false);
              this.toggleInputsRequiredInElement(this.addressForm, true);
              this.toggleInputsDisableInElement(this.deliverySection, false);

              this.deliveryAddressRadios.forEach(radio => {
                radio.dispatchEvent(new Event('change'));
              });

              this.deliveryRadios.forEach(deliveryRadio => {
                deliveryRadio.dispatchEvent(new Event('change'));
              });

              //scroll to the content of the box on mobile
              // if (window.innerWidth < 768) {
              //   smoothScrollTo(this.physicalSection);
              // }

              this.removePhysicalOptionButtons.forEach(button => {
                if(button.classList.contains('on-card') && button.classList.contains('box')){
                  button.classList.remove('hidden');
                  button.classList.remove('lg:invisible');
                  button.classList.remove('lg:block');
                }
                else if(button.classList.contains('on-card') && button.classList.contains('physical')){
                  button.classList.add('hidden');
                  button.classList.add('lg:invisible');
                  button.classList.add('lg:block');
                }
              });

              if(this.langsSelect.value != 1 && this.langsSelect.value != 2){
                this.physicalSection.classList.remove('hidden');
              }

              break;
          }
        }

        this.computeTotalAmount();
      });
    });
  }

  //handle remove physical option
  handleRemovePhysical(){
    this.removePhysicalOptionButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.cardTypes.forEach(cardRadio => {
          cardRadio.checked = false;
        });

        const cardWrapper = this.wrapper.querySelector('.choose-wrapper .vertical-gift-card-choice.selected');
        if(cardWrapper){
          cardWrapper.classList.remove('selected');
        }

        this.resetPhysicalCardLabels();

        if(this.elementsToShowOnPhysical){
          this.elementsToShowOnPhysical.forEach((elt) => {
            elt.classList.add('hidden');
          });
        }

        if(this.elementsToShowOnBox){
          this.elementsToShowOnBox.forEach((elt) => {
            elt.classList.add('hidden');
          });
        }

        this.cartClassicDelivery.classList.add('hidden');
        this.cartExpressDelivery.classList.add('hidden');
        this.deliverySection.classList.add('hidden');

        if(this.physicalSection) this.physicalSection.classList.add('hidden');
        if(this.wineTourismBoxContent) this.wineTourismBoxContent.classList.add('hidden');
        if(this.physicalContent) this.physicalContent.classList.add('hidden');

        this.addressSection.classList.add('hidden');
        this.toggleInputsDisableInElement(this.addressForm, true);
        this.toggleInputsRequiredInElement(this.addressForm, false);
        this.toggleInputsDisableInElement(this.deliverySection, true);

        this.removePhysicalOptionButtons.forEach(innerButton => {
          if(innerButton.classList.contains('on-card')){
            innerButton.classList.add('hidden', 'lg:invisible', 'lg:block');
          }
        });

        //recompute the total amount
        this.computeTotalAmount();
      });
    });
  }

  // handleAmountTypes(){
  //   this.amountTypeRadios.forEach(radio => {
  //     radio.addEventListener('change', () => {
  //       if(radio.checked){
  //         if(radio.value == 'experience-based-amount'){
  //           this.experienceChooseAmount.classList.remove('hidden');
  //           // this.defaultAmountBlock.classList.add('hidden');

  //           this.computeExperienceGiftAmount();
  //           this.amountType.value = 'experience-based';
  //         }
  //         else {
  //           this.experienceChooseAmount.classList.add('hidden');
  //           // this.defaultAmountBlock.classList.remove('hidden');

  //           this.onAmountChange(this.amountInput.value, false);
  //           this.amountType.value = 'default';
  //         }
  //       }
  //     });
  //   });
  // }

  onAmountChange(newAmount, fromRadio = false) {
    this.amountInput.value = newAmount;

    if(fromRadio){
      this.amountInput.parentNode.classList.add("hidden");
      this.otherAmount.classList.remove("hidden");
    }

    let amountFormatted = Number(this.amountInput.value).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
      style: 'currency',
      currency: 'EUR'
    });

    this.cartGiftCardAmountElts.forEach(elt => {
      elt.textContent = amountFormatted;
    });

    //user doesn't want to use experience pricing for determining the GC amount
    this.amountType.value = 'default';

    let triggerScrollToPreventLayoutShift = false;
    if(this.recommendationRemovedBlock){
      triggerScrollToPreventLayoutShift = this.recommendationRemovedBlock.classList.contains('hidden');
      this.recommendationRemovedBlock.classList.remove('hidden');
    }

    if(this.hideOnRemoveReco){
        this.hideOnRemoveReco.forEach(elt => {
        elt.classList.add('hidden');
      });
    }

    //hide the experience seats on the cart
    this.handleCartProductRecapVisibility(true);

    //recompute the total amount
    this.computeTotalAmount();

    //scroll to prevent the layout shift from the removal of the recommendation block
    if (window.innerWidth < 1024 && triggerScrollToPreventLayoutShift) {
      smoothScrollTo(this.chooseAmountBlock);
    }
  }

  onOtherAmountClick() {
    this.amountInput.parentNode.classList.toggle("hidden");
    this.otherAmount.classList.toggle("hidden");
    this.amountInput.focus();

    const amountChecked = this.wrapper.querySelector("input.amountChoice:checked");
    if (amountChecked) {
      amountChecked.checked = false;
    }
  }

  /**
   * Handles the character count of the gift kind words input.
   * Shows the characters count below the textarea.
   * Updates the kindWordsChar element with the character count.
   */
  handleCharsCount(){
    this.giftKindWords.addEventListener('keyup', () => {
      this.kindWordsChar.textContent = this.kindWordsChar.dataset.text.replace('{0}', this.giftKindWords.value.length);
    });

    this.giftKindWords.dispatchEvent(new Event('keyup'));
  }

  /**
   * Handles the event when a card design is chosen (for print or egift types).
   * @return {undefined} This function does not return any value.
   */
  // handleChooseCardDesign(){
  //   const designOptions = this.chooseCardDesign.querySelectorAll("[name='design']");
  //   if(designOptions){
  //     designOptions.forEach(option => {
  //       const selectButton = option.parentElement.querySelector('.selection span');

  //       option.addEventListener('change', () => {
  //         if(option.checked){
  //           designOptions.forEach(innerOption => {
  //             innerOption.parentElement.classList.remove('selected');

  //             const innerSelectButton = innerOption.parentElement.querySelector('.selection span');
  //             innerSelectButton.textContent = innerSelectButton.dataset.select;
  //           });

  //           option.parentElement.classList.add('selected');
  //           selectButton.textContent = selectButton.dataset.selected;
  //         }
  //       });
  //     });
  //   }
  // }

  // handleDeliveryAddressForm(){
  //   this.deliveryAddressRadios.forEach(radio => {
  //     radio.addEventListener('change', () => {
  //       if(radio.checked){
  //         if(radio.value === 'buyer_home'){
  //           //to handle the personal message field
  //           // this.showPersonalMessageNotice(true);
  //         }
  //         else {
  //           //to handle the personal message field
  //           // this.showPersonalMessageNotice(false);
  //         }
  //       }
  //     });
  //   });
  // }

  handleExpressDeliveryFranceOnly(){
    this.countrySelects.forEach(select => {
      select.addEventListener('change', () => {
        this.handleClassicAndExpressVisibility(select.value);
      });
    });

    this.deliveryAddressRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        const form = this.wrapper.querySelector(radio.dataset.form);
        if(form){
          const countrySelect = form.querySelector('.country-select');
          if(countrySelect){
            this.handleClassicAndExpressVisibility(countrySelect.value);
          }
        }
      });
    });
  }

  handleCountryPricing(){
    if(this.regularDeliveryPrice && this.countriesPricing){
      this.countrySelects.forEach(select => {
        select.addEventListener('change', () => {
          this.countryPricingChange(select);
        });
      });
    }
  }

  countryPricingChange(select){
    let countryId = select.value;
    let amount = Number(this.countriesPricing[countryId]).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
      style: 'currency',
      currency: 'EUR'
    });
    this.regularDeliveryPrice.textContent = `+ ${amount}`;

    //also trigger a compute of the total amount
    this.computeTotalAmount();

    //also update the delivery pricing on the cart
    this.classicDeliveryCartPricing.textContent = amount;
  }

  handleClassicAndExpressVisibility(countryValue){
    if(countryValue == 1){
      this.expressChoice.classList.remove('hidden');
    } else {
      this.expressChoice.classList.add('hidden');
      this.classicInput.checked = true;
      this.classicInput.dispatchEvent(new Event('change'));
    }
  }

  handleDelivery(){
    this.deliveryRadios.forEach(deliveryRadio => {
      deliveryRadio.addEventListener('change', () => {
        if(deliveryRadio.checked){
          if(deliveryRadio.value === 'classic'){
            this.cartClassicDelivery.classList.remove('hidden');
            this.cartExpressDelivery.classList.add('hidden');
          }
          else {
            this.cartClassicDelivery.classList.add('hidden');
            this.cartExpressDelivery.classList.remove('hidden');
          }
        }

        this.computeTotalAmount();
      });
    });
  }

  handleExperienceAmount(){
    this.minus.forEach((minus) => {
      const inputNumber = minus.closest('.number-group').querySelector('input');
      minus.addEventListener('click', () => {
        //confirm that the user wants to use experience pricing for determining the GC amount
        this.amountType.value = 'experience-based';

        //if user decides to handle the amount with experience seats, uncheck the amount radio
        this.uncheckCurrentCheckedAmount();

        inputNumber.stepDown();
        this.computeExperienceGiftAmount();
        this.toggleMinimumGroupSizeNotice();

        this.updateTotalSeatsOnCart();
        this.handleCartProductRecapVisibility(false);
      });
    });

    this.plus.forEach((plus) => {
      const inputNumber = plus.closest('.number-group').querySelector('input');
      plus.addEventListener('click', () => {
        //confirm that the user wants to use experience pricing for determining the GC amount
        this.amountType.value = 'experience-based';

        //if user decides to handle the amount with experience seats, uncheck the amount radio
        this.uncheckCurrentCheckedAmount();

        inputNumber.stepUp();
        this.computeExperienceGiftAmount();
        this.toggleMinimumGroupSizeNotice();

        this.updateTotalSeatsOnCart();
        this.handleCartProductRecapVisibility(false);
      });
    });

    this.computeExperienceGiftAmount();
    this.toggleMinimumGroupSizeNotice();
  }

  uncheckCurrentCheckedAmount(){
    let giftCardAmount = this.wrapper.querySelector("input.amountChoice:checked");
    if(giftCardAmount){
      giftCardAmount.checked = false;
    }
  }

  updateTotalSeatsOnCart(){
    let totalPersons = Number(this.adults.value);
    if(this.children){
      totalPersons += Number(this.children.value);
    }

    this.totalSeatsElt.textContent = totalPersons;

    this.handleCartProductRecapVisibility(false);
  }

  handleCartProductRecapVisibility(hideRecapOnCart){
    if(hideRecapOnCart){
      this.regularCartRecap.classList.remove('hidden');
      if(this.experienceCartRecap) this.experienceCartRecap.classList.add('hidden');
      if(this.giftPackageCartRecap) this.giftPackageCartRecap.classList.add('hidden');
    }
    else {
      this.regularCartRecap.classList.add('hidden');
      if(this.experienceCartRecap) this.experienceCartRecap.classList.remove('hidden');
      if(this.giftPackageCartRecap) this.giftPackageCartRecap.classList.remove('hidden');
    }
  }

  computeExperienceGiftAmount(){
    if(this.giftCardAmount){
      let amount = 0
      if(this.useGroupsPricing){
        let totalPersons = Number(this.adults.value);
        if(this.children) totalPersons += Number(this.children.value);

        for(const group of this.groupsPrices){
          if(totalPersons >= group.from_persons && totalPersons <= group.to_persons){
            amount = group.price;
            break;
          }
        }
      }
      else{
        amount = Number(this.adults.value * this.adults.dataset.price);
        if(this.children){
          amount += Number(this.children.value * this.children.dataset.price);
        }
      }

      let amountFormatted = Number(amount).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
        style: 'currency',
        currency: 'EUR'
      });

      this.experienceAmount.value = amount;
      // this.experienceGiftCardAmount.textContent = this.experienceGiftCardAmount.dataset.text.replace('{0}', amountFormatted);
      this.giftCardAmount.forEach((amount) => {
        amount.textContent = amountFormatted;
      });

      this.computeTotalAmount();
    }
  }

  toggleMinimumGroupSizeNotice(){
    let totalPersons = Number(this.adults.value);
    if(this.children){
      totalPersons += Number(this.children.value);
    }

    let minGroupSize = Number(this.experienceChooseAmount.dataset.minPersons);
    if(totalPersons < minGroupSize){
      this.groupSizeNotice.classList.remove('hidden');
    }
    else{
      this.groupSizeNotice.classList.add('hidden');
    }
  }

  //Hide everything in the cart when print is checked
  // handlePrintCartVisibility(){
  //   if(this.elementsToShowOnBox){
  //     this.elementsToShowOnBox.forEach((elt) => {
  //       elt.classList.add('hidden');
  //     });
  //   }

  //   if(this.elementsToShowOnPrint){
  //     this.elementsToShowOnPrint.forEach((elt) => {
  //       elt.classList.remove('hidden');
  //     });
  //   }

  //   if(this.elementsToHideOnPrint){
  //     this.elementsToHideOnPrint.forEach((elt) => {
  //       elt.classList.add('hidden');
  //     });
  //   }
  // }

  //Hide everything in the cart when egift is checked
  // handleElementsToShowOnEgift(){
  //   if(this.elementsToShowOnEgift){
  //     this.elementsToShowOnEgift.forEach((elt) => {
  //       elt.classList.remove('hidden');
  //     });
  //   }

    // if(this.elementsToHideOnEgift){
    //   this.elementsToHideOnEgift.forEach((elt) => {
    //     elt.classList.add('hidden');
    //   });
    // }
  // }

  //Hide everything in the cart when box is checked
  handlePhysicalCartVisibility(){
    if(this.elementsToShowOnPhysical){
      this.elementsToShowOnPhysical.forEach((elt) => {
        elt.classList.remove('hidden');
      });
    }

    if(this.elementsToHideOnPhysical){
      this.elementsToHideOnPhysical.forEach((elt) => {
        elt.classList.add('hidden');
      });
    }
  }

  //Hide everything in the cart when box is checked
  handleBoxCartVisibility(){
    if(this.elementsToShowOnBox){
      this.elementsToShowOnBox.forEach((elt) => {
        elt.classList.remove('hidden');
      });
    }

    if(this.elementsToHideOnBox){
      this.elementsToHideOnBox.forEach((elt) => {
        elt.classList.add('hidden');
      });
    }
  }

  //for mobile UX, where you choose your gift card in a modal
  initMobileChooseGiftCard(){
    this.mobileChooseCards.forEach(card => {
      card.addEventListener('click', () => {
        //remove the active class on the current selected one
        this.mobileChooseCards.forEach(innerCard => {
          innerCard.classList.remove('selected');
        });

        //select the clicked one
        card.classList.add('selected');

        //get the main card input (on tablet/desktop) that corresponds to the card clicked and simulate a change event to trigger the flow
        const mainInput = this.wrapper.querySelector("#" + card.dataset.mainInput);
        if(mainInput){
          mainInput.checked = true;
          mainInput.dispatchEvent(new Event('change'));
        }
      });
    });
  }

  initDatePicker(input) {
    const _this = this;
    flatpickr.localize(flatpickrLanguages[document.body.dataset.lang.substr(0, 2)]);

    return flatpickr(input, {
      altInput: true,
      altFormat: "l, M J, Y",
      dateFormat: "Y-m-d",
      minDate: new Date(),
      defaultDate: new Date(),
      disableMobile: true,
      onChange: function(selectedDates, dateStr){
        let date = selectedDates[0];
        let todayDate = new Date();
        if(date.setHours(0,0,0,0) == todayDate.setHours(0,0,0,0)) {
          _this.sentAtNotice.classList.add('hidden');
        } else {
          _this.sentAtNotice.classList.remove('hidden');
        }
      }
    });
  }

  /**
   * Handles the GC preview modal when a preview button is clicked (showing what the current gift card looks like).
   */
  // handleGCPreview(){
  //   this.previewCurrentGcButtons.forEach(button => {
  //     button.addEventListener('click', () => {
  //       let cardType = this.wrapper.querySelector("input[name='type']:checked");

  //       if(cardType.value === 'print'){
  //         Modal.toggleModal('#moreInfoPrintModal');
  //       }
  //       else if(cardType.value === 'egift'){
  //         Modal.toggleModal('#moreInfoEgiftModal');
  //       }
  //       else if(cardType.value === 'physical'){
  //         Modal.toggleModal('#moreInfoPhysicalModal');
  //       }
  //       else if(cardType.value === 'box'){
  //         Modal.toggleModal('#moreInfoBoxModal');
  //       }
  //     });
  //   });
  // }

  /**
   * Handles the design preview functionality, showing a preview of the design clicked.
   *
   * @param {} - No parameters.
   * @return {} - No return value.
   */
  handleDesignPreview(){
    const previewDesignImages = this.wrapper.querySelectorAll('.preview-design-img');

    if(previewDesignImages){
      this.previewCurrentDesignButtons.forEach(button => {
        button.addEventListener('click', () => {
          let cardType = this.wrapper.querySelector("input[name='type']:checked");
          let design = button.dataset.design;

          //hide all image
          previewDesignImages.forEach(img => {
            img.classList.add('hidden');
          });

          //then show only the current design
          const previewDesignImage = this.wrapper.querySelector(`.preview-design-img[data-design="${design}"][data-type="${cardType.value}"]`);
          previewDesignImage?.classList.remove('hidden');
        });
      });
    }
  }

  computeTotalAmount(){
    let totalAmount = 0;

    let giftCardType = this.wrapper.querySelector("input[name='type']:checked");
    if(giftCardType && giftCardType.value === 'box'){
      totalAmount += Number(this.wrapper.dataset.boxExtra);
      this.amountWithFullBoxPrice.classList.remove('hidden');
      this.totalCartAmount.classList.add('text-me-red');

      this.amountWithFullBoxPriceFooter.classList.remove('hidden');
      this.totalCartAmountFooter.classList.add('text-me-red');

      this.mobileAmountWithFullBoxPrice.classList.remove('hidden');
      this.mobileTotalCartAmount.classList.add('text-me-red');
    }
    else if(giftCardType && giftCardType.value === 'physical'){
      totalAmount += Number(this.wrapper.dataset.physicalExtra);
    }

    if((giftCardType && giftCardType.value != 'box') || !giftCardType){
      this.amountWithFullBoxPrice.classList.add('hidden');
      this.totalCartAmount.classList.remove('text-me-red');

      this.amountWithFullBoxPriceFooter.classList.add('hidden');
      this.totalCartAmountFooter.classList.remove('text-me-red');

      this.mobileAmountWithFullBoxPrice.classList.add('hidden');
      this.mobileTotalCartAmount.classList.remove('text-me-red');
    }

    //Gift card value, used for the promo code minimum amount
    let giftCardValue = 0;

    if(this.amountType.value == 'default'){
      let giftCardAmount = this.wrapper.querySelector("input.amountChoice:checked");
      if(giftCardAmount && !isHiddenAlt(giftCardAmount.parentElement)){ //If an amount radio choice is checked
        giftCardValue = Number(giftCardAmount.value);
      }
      else if(this.amountInput && !isHiddenAlt(this.amountInput)) { //If a manual amount was typed in the input
        giftCardValue = Number(this.amountInput.value);
      }
    }
    else{
      //If it's an amount based on a recommended experience
      if(this.experienceAmount){
        giftCardValue = Number(this.experienceAmount.value);
      }
      else if(this.giftPackageAmount){
        giftCardValue = Number(this.giftPackageAmount.value);
      }
    }

    totalAmount += giftCardValue;

    let deliveryAmount = 0;
    let delivery = this.wrapper.querySelector("input[name='delivery_type']:checked");
    if(delivery && !isHiddenAlt(delivery.parentElement) && delivery.value === 'classic')
    {
      // totalAmount += Number(this.wrapper.dataset.classicDelivery);

      //get the right delivery form depending on what the user chose (send to me or send to recipient)
      let countryId = this.addressForm.querySelector('.country-select').value;
      deliveryAmount = Number(this.countriesPricing[countryId]);

      this.withDeliveryTexts.forEach(text => {
        text.classList.remove('hidden');
      });
    }
    else if(delivery && !isHiddenAlt(delivery.parentElement) && delivery.value === 'express'){
      deliveryAmount = Number(this.wrapper.dataset.expressDelivery);
      this.withDeliveryTexts.forEach(text => {
        text.classList.remove('hidden');
      });
    }
    else{
      this.withDeliveryTexts.forEach(text => {
        text.classList.add('hidden');
      });
    }

    totalAmount += deliveryAmount;

    //We store the value on a input hidden (which will be verified server side!)
    //The promo code is applied at checkout, so the stored amount stays without discount
    this.amount.value = totalAmount;

    const promoDiscount = this.computePromoDiscount(giftCardValue, totalAmount - deliveryAmount, totalAmount);
    this.updatePromoDiscountLine(promoDiscount);

    //We show the total amount on the cart
    let amountFormatted = Number(totalAmount - promoDiscount).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
      style: 'currency',
      currency: 'EUR'
    });
    this.totalCartAmount.textContent = amountFormatted;
    this.mobileTotalCartAmount.textContent = amountFormatted;
    this.totalCartAmountFooter.textContent = amountFormatted;

    if(giftCardType && giftCardType.value === 'box'){
      //19.5 = difference between box products in the commerce vs products
      let fullBoxPrice = Number(totalAmount + 19.5).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
        style: 'currency',
        currency: 'EUR'
      });

      this.amountWithFullBoxPrice.textContent = fullBoxPrice;
      this.amountWithFullBoxPriceFooter.textContent = fullBoxPrice;
      this.mobileAmountWithFullBoxPrice.textContent = fullBoxPrice;
    }
  }

  /**
   * Discount of the session promo code, with the same rules as the checkout (CartGiftTable::computeDiscountAmounts)
   * @param {number} giftCardValue Gift card value, compared to the promo minimum and maximum amounts
   * @param {number} totalWithoutDelivery Total without delivery (a percentage never applies to the delivery)
   * @param {number} total Total with delivery
   * @returns {number} Discount in euros, 0 when the promo does not apply
   */
  computePromoDiscount(giftCardValue, totalWithoutDelivery, total){
    if(!this.promo
      || giftCardValue <= 0
      || giftCardValue < this.promo.minimum
      || (this.promo.maximum > 0 && giftCardValue > this.promo.maximum)
    ){
      return 0;
    }

    const discount = this.promo.isPercentage
      ? Math.round(totalWithoutDelivery * this.promo.value) / 100
      : this.promo.value;

    return total - discount > 0 ? discount : 0;
  }

  /**
   * Show the promo code discount line in the cart recap
   * @param {number} discount Discount in euros
   */
  updatePromoDiscountLine(discount){
    if(!this.cartPromoDiscount || !this.cartPromoDiscountAmount){
      return;
    }

    this.cartPromoDiscount.classList.toggle('hidden', discount <= 0);
    this.cartPromoDiscountAmount.textContent = '-' + Number(discount).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
      style: 'currency',
      currency: 'EUR'
    });
  }

  //Disable all inputs / selects inside a html element
  toggleInputsDisableInElement(element, toggleDisabled = true){
    const inputs = element.querySelectorAll('input');
    const selects = element.querySelectorAll('select');
    if(inputs){
      inputs.forEach(input => {
        input.disabled = toggleDisabled;
      });
    }

    if(selects){
      selects.forEach(select => {
        select.disabled = toggleDisabled;
      });
    }
  }

  //Disable required attribute for all inputs / selects inside a html element
  toggleInputsRequiredInElement(element, toggleRequired = true){
    const inputs = element.querySelectorAll('input:not(.ignore)');
    const selects = element.querySelectorAll('select:not(.ignore)');
    if(inputs){
      inputs.forEach(input => {
        input.required = toggleRequired;
      });
    }

    if(selects){
      selects.forEach(select => {
        select.required = toggleRequired;
      });
    }
  }

  // showPersonalMessageNotice(show){
  //   //to handle the personal message field
  //   // this.personalMessageNotice.classList.toggle('hidden', !show);
  //   this.giftKindWords.parentElement.classList.toggle('hidden', show);
  //   this.kindWordsChar.classList.toggle('hidden', show);
  // }

  resetPhysicalCardLabels(){
    const wrapper = this.wrapper.querySelector('.choose-wrapper');
    if(wrapper){
      const labels = wrapper.querySelectorAll('.select-label');
      if(labels){
        labels.forEach(label => {
          label.textContent = label.dataset.select;
        });
      }
    }
  }

  resetEgiftCardLabels(){
    const wrapper = this.wrapper.querySelector('.add-egift-section');
    if(wrapper){
      const labels = wrapper.querySelectorAll('.select-label');
      if(labels){
        labels.forEach(label => {
          label.textContent = label.dataset.select;
        });
      }
    }
  }

  //toggle disable/hidden on langs depending on card type
  //ex: if card is physical or box, we only want FR/EN
  // toggleLangsAvailable(restrict = true){
  //   if(this.langsSelect){
  //     const unrestrictedLangsOptions = this.langsSelect.querySelectorAll(':not([data-lang-physical])');

  //     if(restrict){
  //       unrestrictedLangsOptions.forEach(option => {
  //         option.disabled = true;
  //         option.classList.add('hidden');
  //       });

  //       //if the currently select lang was in unrestricted langs
  //       //select the default option fallback (which is english - id = 2)
  //       if(this.langsSelect.value > 2){
  //         this.langsSelect.value = 2;
  //       }
  //     }
  //     else{
  //       unrestrictedLangsOptions.forEach(option => {
  //         option.disabled = false;
  //         option.classList.remove('hidden');
  //       });
  //     }
  //   }
  // }
}

export default GiftSelect;
